import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "articulosKioskCache";

// Cargar estado inicial desde localStorage
const loadFromLocalStorage = () => {
  try {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (error) {
    console.error("Error cargando artículos desde localStorage:", error);
  }
  return { articulosPorGrupo: {} };
};

const initialState = loadFromLocalStorage();

export const articulosKioskSlice = createSlice({
  name: "articulosKiosk",
  initialState,
  reducers: {
    guardarArticulosGrupo: (state, action) => {
      const { grupoId, articulos } = action.payload;
      state.articulosPorGrupo[grupoId] = articulos;
      
      // Guardar en localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (error) {
        console.error("Error guardando artículos en localStorage:", error);
      }
    },
    limpiarArticulosKiosk: (state) => {
      state.articulosPorGrupo = {};
      
      // Limpiar localStorage
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        console.error("Error limpiando artículos de localStorage:", error);
      }
    },
  },
});

export const { guardarArticulosGrupo, limpiarArticulosKiosk } = articulosKioskSlice.actions;
